"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const chart_color_blue_100_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_blue_100"));
const chart_color_blue_200_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_blue_200"));
const chart_color_blue_300_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_blue_300"));
const chart_color_blue_400_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_blue_400"));
const chart_color_blue_500_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_blue_500"));
const chart_color_green_100_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_green_100"));
const chart_color_green_200_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_green_200"));
const chart_color_green_300_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_green_300"));
const chart_color_green_400_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_green_400"));
const chart_color_green_500_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_green_500"));
const chart_color_cyan_100_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_cyan_100"));
const chart_color_cyan_200_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_cyan_200"));
const chart_color_cyan_300_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_cyan_300"));
const chart_color_cyan_400_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_cyan_400"));
const chart_color_cyan_500_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_cyan_500"));
const chart_color_purple_100_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_100"));
const chart_color_purple_200_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_200"));
const chart_color_purple_300_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_300"));
const chart_color_purple_400_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_400"));
const chart_color_purple_500_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_500"));
const chart_color_gold_100_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_gold_100"));
const chart_color_gold_200_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_gold_200"));
const chart_color_gold_300_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_gold_300"));
const chart_color_gold_400_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_gold_400"));
const chart_color_gold_500_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_gold_500"));
const chart_color_orange_100_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_orange_100"));
const chart_color_orange_200_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_orange_200"));
const chart_color_orange_300_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_orange_300"));
const chart_color_orange_400_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_orange_400"));
const chart_color_orange_500_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_orange_500"));
const chart_color_black_100_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_black_100"));
const chart_color_black_200_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_black_200"));
const chart_color_black_300_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_black_300"));
const chart_color_black_400_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_black_400"));
const chart_color_black_500_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_black_500"));
const color_theme_1 = require("../color-theme");
// The color order below improves the color contrast in unordered charts; area & line
// See https://github.com/patternfly/patternfly-next/issues/1551
const COLOR_SCALE = [
    chart_color_blue_300_1.default.value,
    chart_color_gold_300_1.default.value,
    chart_color_green_300_1.default.value,
    chart_color_purple_300_1.default.value,
    chart_color_orange_300_1.default.value,
    chart_color_cyan_300_1.default.value,
    chart_color_black_300_1.default.value,
    chart_color_blue_100_1.default.value,
    chart_color_gold_500_1.default.value,
    chart_color_green_100_1.default.value,
    chart_color_purple_500_1.default.value,
    chart_color_orange_100_1.default.value,
    chart_color_cyan_500_1.default.value,
    chart_color_black_100_1.default.value,
    chart_color_blue_500_1.default.value,
    chart_color_gold_100_1.default.value,
    chart_color_green_500_1.default.value,
    chart_color_purple_100_1.default.value,
    chart_color_orange_500_1.default.value,
    chart_color_cyan_100_1.default.value,
    chart_color_black_500_1.default.value,
    chart_color_blue_200_1.default.value,
    chart_color_gold_400_1.default.value,
    chart_color_green_200_1.default.value,
    chart_color_purple_400_1.default.value,
    chart_color_orange_200_1.default.value,
    chart_color_cyan_400_1.default.value,
    chart_color_black_200_1.default.value,
    chart_color_blue_400_1.default.value,
    chart_color_gold_200_1.default.value,
    chart_color_green_400_1.default.value,
    chart_color_purple_200_1.default.value,
    chart_color_orange_400_1.default.value,
    chart_color_cyan_200_1.default.value,
    chart_color_black_400_1.default.value
];
exports.LightMultiColorUnorderedTheme = color_theme_1.ColorTheme({
    COLOR_SCALE
});
//# sourceMappingURL=multi-color-unordered-theme.js.map